import { memo as _$memo } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { createComponent as _$createComponent } from "@opentui/solid";
import { effect as _$effect } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { useSync } from "@tui/context/sync";
import { createMemo, For, Show, Switch, Match } from "solid-js";
import { createStore } from "solid-js/store";
import { useTheme } from "../../context/theme";
import { Installation } from "@/installation";
import { useDirectory } from "../../context/directory";
import { useKV } from "../../context/kv";
import { TodoItem } from "../../component/todo-item";
export function Sidebar(props) {
  const sync = useSync();
  const {
    theme
  } = useTheme();
  const session = createMemo(() => sync.session.get(props.sessionID));
  const diff = createMemo(() => sync.data.session_diff[props.sessionID] ?? []);
  const todo = createMemo(() => sync.data.todo[props.sessionID] ?? []);
  const messages = createMemo(() => sync.data.message[props.sessionID] ?? []);
  const [expanded, setExpanded] = createStore({
    mcp: true,
    diff: true,
    todo: true,
    lsp: true
  });

  // Sort MCP servers alphabetically for consistent display order
  const mcpEntries = createMemo(() => Object.entries(sync.data.mcp).sort(([a], [b]) => a.localeCompare(b)));

  // Count connected and error MCP servers for collapsed header display
  const connectedMcpCount = createMemo(() => mcpEntries().filter(([_, item]) => item.status === "connected").length);
  const errorMcpCount = createMemo(() => mcpEntries().filter(([_, item]) => item.status === "failed" || item.status === "needs_auth" || item.status === "needs_client_registration").length);
  const cost = createMemo(() => {
    const total = messages().reduce((sum, x) => sum + (x.role === "assistant" ? x.cost : 0), 0);
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(total);
  });
  const context = createMemo(() => {
    const last = messages().findLast(x => x.role === "assistant" && x.tokens.output > 0);
    if (!last) return;
    const total = last.tokens.input + last.tokens.output + last.tokens.reasoning + last.tokens.cache.read + last.tokens.cache.write;
    const model = sync.data.provider.find(x => x.id === last.providerID)?.models[last.modelID];
    return {
      tokens: total.toLocaleString(),
      percentage: model?.limit.context ? Math.round(total / model.limit.context * 100) : null
    };
  });
  const directory = useDirectory();
  const kv = useKV();
  const hasProviders = createMemo(() => sync.data.provider.some(x => x.id !== "opencode" || Object.values(x.models).some(y => y.cost?.input !== 0)));
  const gettingStartedDismissed = createMemo(() => kv.get("dismissed_getting_started", false));
  return _$createComponent(Show, {
    get when() {
      return session();
    },
    get children() {
      var _el$ = _$createElement("box"),
        _el$2 = _$createElement("scrollbox"),
        _el$3 = _$createElement("box"),
        _el$4 = _$createElement("box"),
        _el$5 = _$createElement("text"),
        _el$6 = _$createElement("b"),
        _el$8 = _$createElement("box"),
        _el$9 = _$createElement("text"),
        _el$0 = _$createElement("b"),
        _el$10 = _$createElement("text"),
        _el$11 = _$createTextNode(` tokens`),
        _el$12 = _$createElement("text"),
        _el$13 = _$createTextNode(`% used`),
        _el$14 = _$createElement("text"),
        _el$15 = _$createTextNode(` spent`),
        _el$27 = _$createElement("box"),
        _el$28 = _$createElement("box"),
        _el$30 = _$createElement("text"),
        _el$31 = _$createElement("b"),
        _el$46 = _$createElement("box"),
        _el$66 = _$createElement("text"),
        _el$67 = _$createElement("span"),
        _el$68 = _$createTextNode(`/`),
        _el$69 = _$createElement("span"),
        _el$70 = _$createElement("text"),
        _el$71 = _$createElement("span"),
        _el$73 = _$createTextNode(` `),
        _el$74 = _$createElement("b"),
        _el$76 = _$createElement("span"),
        _el$77 = _$createElement("b"),
        _el$79 = _$createTextNode(` `),
        _el$80 = _$createElement("span");
      _$insertNode(_el$, _el$2);
      _$insertNode(_el$, _el$46);
      _$setProp(_el$, "width", 42);
      _$setProp(_el$, "height", "100%");
      _$setProp(_el$, "paddingTop", 1);
      _$setProp(_el$, "paddingBottom", 1);
      _$setProp(_el$, "paddingLeft", 2);
      _$setProp(_el$, "paddingRight", 2);
      _$insertNode(_el$2, _el$3);
      _$setProp(_el$2, "flexGrow", 1);
      _$insertNode(_el$3, _el$4);
      _$insertNode(_el$3, _el$8);
      _$insertNode(_el$3, _el$27);
      _$setProp(_el$3, "flexShrink", 0);
      _$setProp(_el$3, "gap", 1);
      _$setProp(_el$3, "paddingRight", 1);
      _$insertNode(_el$4, _el$5);
      _$setProp(_el$4, "paddingRight", 1);
      _$insertNode(_el$5, _el$6);
      _$insert(_el$6, () => session().title);
      _$insert(_el$4, _$createComponent(Show, {
        get when() {
          return session().share?.url;
        },
        get children() {
          var _el$7 = _$createElement("text");
          _$insert(_el$7, () => session().share.url);
          _$effect(_$p => _$setProp(_el$7, "fg", theme.textMuted, _$p));
          return _el$7;
        }
      }), null);
      _$insertNode(_el$8, _el$9);
      _$insertNode(_el$8, _el$10);
      _$insertNode(_el$8, _el$12);
      _$insertNode(_el$8, _el$14);
      _$insertNode(_el$9, _el$0);
      _$insertNode(_el$0, _$createTextNode(`Context`));
      _$insertNode(_el$10, _el$11);
      _$insert(_el$10, () => context()?.tokens ?? 0, _el$11);
      _$insertNode(_el$12, _el$13);
      _$insert(_el$12, () => context()?.percentage ?? 0, _el$13);
      _$insertNode(_el$14, _el$15);
      _$insert(_el$14, cost, _el$15);
      _$insert(_el$3, _$createComponent(Show, {
        get when() {
          return mcpEntries().length > 0;
        },
        get children() {
          var _el$16 = _$createElement("box"),
            _el$17 = _$createElement("box"),
            _el$19 = _$createElement("text"),
            _el$20 = _$createElement("b");
          _$insertNode(_el$16, _el$17);
          _$insertNode(_el$17, _el$19);
          _$setProp(_el$17, "flexDirection", "row");
          _$setProp(_el$17, "gap", 1);
          _$setProp(_el$17, "onMouseDown", () => mcpEntries().length > 2 && setExpanded("mcp", !expanded.mcp));
          _$insert(_el$17, _$createComponent(Show, {
            get when() {
              return mcpEntries().length > 2;
            },
            get children() {
              var _el$18 = _$createElement("text");
              _$insert(_el$18, () => expanded.mcp ? "▼" : "▶");
              _$effect(_$p => _$setProp(_el$18, "fg", theme.text, _$p));
              return _el$18;
            }
          }), _el$19);
          _$insertNode(_el$19, _el$20);
          _$insertNode(_el$20, _$createTextNode(`MCP`));
          _$insert(_el$19, _$createComponent(Show, {
            get when() {
              return !expanded.mcp;
            },
            get children() {
              var _el$22 = _$createElement("span"),
                _el$23 = _$createTextNode(` (`),
                _el$25 = _$createTextNode(` active`),
                _el$26 = _$createTextNode(`)`);
              _$insertNode(_el$22, _el$23);
              _$insertNode(_el$22, _el$25);
              _$insertNode(_el$22, _el$26);
              _$insert(_el$22, connectedMcpCount, _el$25);
              _$insert(_el$22, (() => {
                var _c$ = _$memo(() => errorMcpCount() > 0);
                return () => _c$() ? `, ${errorMcpCount()} error${errorMcpCount() > 1 ? "s" : ""}` : "";
              })(), _el$26);
              _$effect(_$p => _$setProp(_el$22, "style", {
                fg: theme.textMuted
              }, _$p));
              return _el$22;
            }
          }), null);
          _$insert(_el$16, _$createComponent(Show, {
            get when() {
              return mcpEntries().length <= 2 || expanded.mcp;
            },
            get children() {
              return _$createComponent(For, {
                get each() {
                  return mcpEntries();
                },
                children: ([key, item]) => (() => {
                  var _el$81 = _$createElement("box"),
                    _el$82 = _$createElement("text"),
                    _el$84 = _$createElement("text"),
                    _el$85 = _$createTextNode(` `),
                    _el$86 = _$createElement("span");
                  _$insertNode(_el$81, _el$82);
                  _$insertNode(_el$81, _el$84);
                  _$setProp(_el$81, "flexDirection", "row");
                  _$setProp(_el$81, "gap", 1);
                  _$insertNode(_el$82, _$createTextNode(`•`));
                  _$setProp(_el$82, "flexShrink", 0);
                  _$insertNode(_el$84, _el$85);
                  _$insertNode(_el$84, _el$86);
                  _$setProp(_el$84, "wrapMode", "word");
                  _$insert(_el$84, key, _el$85);
                  _$insert(_el$86, _$createComponent(Switch, {
                    get fallback() {
                      return item.status;
                    },
                    get children() {
                      return [_$createComponent(Match, {
                        get when() {
                          return item.status === "connected";
                        },
                        children: "Connected"
                      }), _$createComponent(Match, {
                        get when() {
                          return item.status === "failed" && item;
                        },
                        children: val => (() => {
                          var _el$87 = _$createElement("i");
                          _$insert(_el$87, () => val().error);
                          return _el$87;
                        })()
                      }), _$createComponent(Match, {
                        get when() {
                          return item.status === "disabled";
                        },
                        children: "Disabled"
                      }), _$createComponent(Match, {
                        get when() {
                          return item.status === "needs_auth";
                        },
                        children: "Needs auth"
                      }), _$createComponent(Match, {
                        get when() {
                          return item.status === "needs_client_registration";
                        },
                        children: "Needs client ID"
                      })];
                    }
                  }));
                  _$effect(_p$ => {
                    var _v$21 = {
                        fg: {
                          connected: theme.success,
                          failed: theme.error,
                          disabled: theme.textMuted,
                          needs_auth: theme.warning,
                          needs_client_registration: theme.error
                        }[item.status]
                      },
                      _v$22 = theme.text,
                      _v$23 = {
                        fg: theme.textMuted
                      };
                    _v$21 !== _p$.e && (_p$.e = _$setProp(_el$82, "style", _v$21, _p$.e));
                    _v$22 !== _p$.t && (_p$.t = _$setProp(_el$84, "fg", _v$22, _p$.t));
                    _v$23 !== _p$.a && (_p$.a = _$setProp(_el$86, "style", _v$23, _p$.a));
                    return _p$;
                  }, {
                    e: undefined,
                    t: undefined,
                    a: undefined
                  });
                  return _el$81;
                })()
              });
            }
          }), null);
          _$effect(_$p => _$setProp(_el$19, "fg", theme.text, _$p));
          return _el$16;
        }
      }), _el$27);
      _$insertNode(_el$27, _el$28);
      _$insertNode(_el$28, _el$30);
      _$setProp(_el$28, "flexDirection", "row");
      _$setProp(_el$28, "gap", 1);
      _$setProp(_el$28, "onMouseDown", () => sync.data.lsp.length > 2 && setExpanded("lsp", !expanded.lsp));
      _$insert(_el$28, _$createComponent(Show, {
        get when() {
          return sync.data.lsp.length > 2;
        },
        get children() {
          var _el$29 = _$createElement("text");
          _$insert(_el$29, () => expanded.lsp ? "▼" : "▶");
          _$effect(_$p => _$setProp(_el$29, "fg", theme.text, _$p));
          return _el$29;
        }
      }), _el$30);
      _$insertNode(_el$30, _el$31);
      _$insertNode(_el$31, _$createTextNode(`LSP`));
      _$insert(_el$27, _$createComponent(Show, {
        get when() {
          return sync.data.lsp.length <= 2 || expanded.lsp;
        },
        get children() {
          return [_$createComponent(Show, {
            get when() {
              return sync.data.lsp.length === 0;
            },
            get children() {
              var _el$33 = _$createElement("text");
              _$insert(_el$33, () => sync.data.config.lsp === false ? "LSPs have been disabled in settings" : "LSPs will activate as files are read");
              _$effect(_$p => _$setProp(_el$33, "fg", theme.textMuted, _$p));
              return _el$33;
            }
          }), _$createComponent(For, {
            get each() {
              return sync.data.lsp;
            },
            children: item => (() => {
              var _el$88 = _$createElement("box"),
                _el$89 = _$createElement("text"),
                _el$91 = _$createElement("text"),
                _el$92 = _$createTextNode(` `);
              _$insertNode(_el$88, _el$89);
              _$insertNode(_el$88, _el$91);
              _$setProp(_el$88, "flexDirection", "row");
              _$setProp(_el$88, "gap", 1);
              _$insertNode(_el$89, _$createTextNode(`•`));
              _$setProp(_el$89, "flexShrink", 0);
              _$insertNode(_el$91, _el$92);
              _$insert(_el$91, () => item.id, _el$92);
              _$insert(_el$91, () => item.root, null);
              _$effect(_p$ => {
                var _v$24 = {
                    fg: {
                      connected: theme.success,
                      error: theme.error
                    }[item.status]
                  },
                  _v$25 = theme.textMuted;
                _v$24 !== _p$.e && (_p$.e = _$setProp(_el$89, "style", _v$24, _p$.e));
                _v$25 !== _p$.t && (_p$.t = _$setProp(_el$91, "fg", _v$25, _p$.t));
                return _p$;
              }, {
                e: undefined,
                t: undefined
              });
              return _el$88;
            })()
          })];
        }
      }), null);
      _$insert(_el$3, _$createComponent(Show, {
        get when() {
          return _$memo(() => todo().length > 0)() && todo().some(t => t.status !== "completed");
        },
        get children() {
          var _el$34 = _$createElement("box"),
            _el$35 = _$createElement("box"),
            _el$37 = _$createElement("text"),
            _el$38 = _$createElement("b");
          _$insertNode(_el$34, _el$35);
          _$insertNode(_el$35, _el$37);
          _$setProp(_el$35, "flexDirection", "row");
          _$setProp(_el$35, "gap", 1);
          _$setProp(_el$35, "onMouseDown", () => todo().length > 2 && setExpanded("todo", !expanded.todo));
          _$insert(_el$35, _$createComponent(Show, {
            get when() {
              return todo().length > 2;
            },
            get children() {
              var _el$36 = _$createElement("text");
              _$insert(_el$36, () => expanded.todo ? "▼" : "▶");
              _$effect(_$p => _$setProp(_el$36, "fg", theme.text, _$p));
              return _el$36;
            }
          }), _el$37);
          _$insertNode(_el$37, _el$38);
          _$insertNode(_el$38, _$createTextNode(`Todo`));
          _$insert(_el$34, _$createComponent(Show, {
            get when() {
              return todo().length <= 2 || expanded.todo;
            },
            get children() {
              return _$createComponent(For, {
                get each() {
                  return todo();
                },
                children: todo => _$createComponent(TodoItem, {
                  get status() {
                    return todo.status;
                  },
                  get content() {
                    return todo.content;
                  }
                })
              });
            }
          }), null);
          _$effect(_$p => _$setProp(_el$37, "fg", theme.text, _$p));
          return _el$34;
        }
      }), null);
      _$insert(_el$3, _$createComponent(Show, {
        get when() {
          return diff().length > 0;
        },
        get children() {
          var _el$40 = _$createElement("box"),
            _el$41 = _$createElement("box"),
            _el$43 = _$createElement("text"),
            _el$44 = _$createElement("b");
          _$insertNode(_el$40, _el$41);
          _$insertNode(_el$41, _el$43);
          _$setProp(_el$41, "flexDirection", "row");
          _$setProp(_el$41, "gap", 1);
          _$setProp(_el$41, "onMouseDown", () => diff().length > 2 && setExpanded("diff", !expanded.diff));
          _$insert(_el$41, _$createComponent(Show, {
            get when() {
              return diff().length > 2;
            },
            get children() {
              var _el$42 = _$createElement("text");
              _$insert(_el$42, () => expanded.diff ? "▼" : "▶");
              _$effect(_$p => _$setProp(_el$42, "fg", theme.text, _$p));
              return _el$42;
            }
          }), _el$43);
          _$insertNode(_el$43, _el$44);
          _$insertNode(_el$44, _$createTextNode(`Modified Files`));
          _$insert(_el$40, _$createComponent(Show, {
            get when() {
              return diff().length <= 2 || expanded.diff;
            },
            get children() {
              return _$createComponent(For, {
                get each() {
                  return diff() || [];
                },
                children: item => {
                  return (() => {
                    var _el$93 = _$createElement("box"),
                      _el$94 = _$createElement("text"),
                      _el$95 = _$createElement("box");
                    _$insertNode(_el$93, _el$94);
                    _$insertNode(_el$93, _el$95);
                    _$setProp(_el$93, "flexDirection", "row");
                    _$setProp(_el$93, "gap", 1);
                    _$setProp(_el$93, "justifyContent", "space-between");
                    _$setProp(_el$94, "wrapMode", "none");
                    _$insert(_el$94, () => item.file);
                    _$setProp(_el$95, "flexDirection", "row");
                    _$setProp(_el$95, "gap", 1);
                    _$setProp(_el$95, "flexShrink", 0);
                    _$insert(_el$95, _$createComponent(Show, {
                      get when() {
                        return item.additions;
                      },
                      get children() {
                        var _el$96 = _$createElement("text"),
                          _el$97 = _$createTextNode(`+`);
                        _$insertNode(_el$96, _el$97);
                        _$insert(_el$96, () => item.additions, null);
                        _$effect(_$p => _$setProp(_el$96, "fg", theme.diffAdded, _$p));
                        return _el$96;
                      }
                    }), null);
                    _$insert(_el$95, _$createComponent(Show, {
                      get when() {
                        return item.deletions;
                      },
                      get children() {
                        var _el$98 = _$createElement("text"),
                          _el$99 = _$createTextNode(`-`);
                        _$insertNode(_el$98, _el$99);
                        _$insert(_el$98, () => item.deletions, null);
                        _$effect(_$p => _$setProp(_el$98, "fg", theme.diffRemoved, _$p));
                        return _el$98;
                      }
                    }), null);
                    _$effect(_$p => _$setProp(_el$94, "fg", theme.textMuted, _$p));
                    return _el$93;
                  })();
                }
              });
            }
          }), null);
          _$effect(_$p => _$setProp(_el$43, "fg", theme.text, _$p));
          return _el$40;
        }
      }), null);
      _$insertNode(_el$46, _el$66);
      _$insertNode(_el$46, _el$70);
      _$setProp(_el$46, "flexShrink", 0);
      _$setProp(_el$46, "gap", 1);
      _$setProp(_el$46, "paddingTop", 1);
      _$insert(_el$46, _$createComponent(Show, {
        get when() {
          return _$memo(() => !!!hasProviders())() && !gettingStartedDismissed();
        },
        get children() {
          var _el$47 = _$createElement("box"),
            _el$48 = _$createElement("text"),
            _el$50 = _$createElement("box"),
            _el$51 = _$createElement("box"),
            _el$52 = _$createElement("text"),
            _el$53 = _$createElement("b"),
            _el$55 = _$createElement("text"),
            _el$57 = _$createElement("text"),
            _el$59 = _$createElement("text"),
            _el$61 = _$createElement("box"),
            _el$62 = _$createElement("text"),
            _el$64 = _$createElement("text");
          _$insertNode(_el$47, _el$48);
          _$insertNode(_el$47, _el$50);
          _$setProp(_el$47, "paddingTop", 1);
          _$setProp(_el$47, "paddingBottom", 1);
          _$setProp(_el$47, "paddingLeft", 2);
          _$setProp(_el$47, "paddingRight", 2);
          _$setProp(_el$47, "flexDirection", "row");
          _$setProp(_el$47, "gap", 1);
          _$insertNode(_el$48, _$createTextNode(`⬖`));
          _$setProp(_el$48, "flexShrink", 0);
          _$insertNode(_el$50, _el$51);
          _$insertNode(_el$50, _el$57);
          _$insertNode(_el$50, _el$59);
          _$insertNode(_el$50, _el$61);
          _$setProp(_el$50, "flexGrow", 1);
          _$setProp(_el$50, "gap", 1);
          _$insertNode(_el$51, _el$52);
          _$insertNode(_el$51, _el$55);
          _$setProp(_el$51, "flexDirection", "row");
          _$setProp(_el$51, "justifyContent", "space-between");
          _$insertNode(_el$52, _el$53);
          _$insertNode(_el$53, _$createTextNode(`Getting started`));
          _$insertNode(_el$55, _$createTextNode(`✕`));
          _$setProp(_el$55, "onMouseDown", () => kv.set("dismissed_getting_started", true));
          _$insertNode(_el$57, _$createTextNode(`OpenCode includes free models so you can start immediately.`));
          _$insertNode(_el$59, _$createTextNode(`Connect from 75+ providers to use other models, including Claude, GPT, Gemini etc`));
          _$insertNode(_el$61, _el$62);
          _$insertNode(_el$61, _el$64);
          _$setProp(_el$61, "flexDirection", "row");
          _$setProp(_el$61, "gap", 1);
          _$setProp(_el$61, "justifyContent", "space-between");
          _$insertNode(_el$62, _$createTextNode(`Connect provider`));
          _$insertNode(_el$64, _$createTextNode(`/connect`));
          _$effect(_p$ => {
            var _v$ = theme.backgroundElement,
              _v$2 = theme.text,
              _v$3 = theme.text,
              _v$4 = theme.textMuted,
              _v$5 = theme.textMuted,
              _v$6 = theme.textMuted,
              _v$7 = theme.text,
              _v$8 = theme.textMuted;
            _v$ !== _p$.e && (_p$.e = _$setProp(_el$47, "backgroundColor", _v$, _p$.e));
            _v$2 !== _p$.t && (_p$.t = _$setProp(_el$48, "fg", _v$2, _p$.t));
            _v$3 !== _p$.a && (_p$.a = _$setProp(_el$52, "fg", _v$3, _p$.a));
            _v$4 !== _p$.o && (_p$.o = _$setProp(_el$55, "fg", _v$4, _p$.o));
            _v$5 !== _p$.i && (_p$.i = _$setProp(_el$57, "fg", _v$5, _p$.i));
            _v$6 !== _p$.n && (_p$.n = _$setProp(_el$59, "fg", _v$6, _p$.n));
            _v$7 !== _p$.s && (_p$.s = _$setProp(_el$62, "fg", _v$7, _p$.s));
            _v$8 !== _p$.h && (_p$.h = _$setProp(_el$64, "fg", _v$8, _p$.h));
            return _p$;
          }, {
            e: undefined,
            t: undefined,
            a: undefined,
            o: undefined,
            i: undefined,
            n: undefined,
            s: undefined,
            h: undefined
          });
          return _el$47;
        }
      }), _el$66);
      _$insertNode(_el$66, _el$67);
      _$insertNode(_el$66, _el$69);
      _$insertNode(_el$67, _el$68);
      _$insert(_el$67, () => directory().split("/").slice(0, -1).join("/"), _el$68);
      _$insert(_el$69, () => directory().split("/").at(-1));
      _$insertNode(_el$70, _el$71);
      _$insertNode(_el$70, _el$73);
      _$insertNode(_el$70, _el$74);
      _$insertNode(_el$70, _el$76);
      _$insertNode(_el$70, _el$79);
      _$insertNode(_el$70, _el$80);
      _$insertNode(_el$71, _$createTextNode(`•`));
      _$insertNode(_el$74, _$createTextNode(`Open`));
      _$insertNode(_el$76, _el$77);
      _$insertNode(_el$77, _$createTextNode(`Code`));
      _$insert(_el$80, () => Installation.VERSION);
      _$effect(_p$ => {
        var _v$9 = theme.backgroundPanel,
          _v$0 = props.overlay ? "absolute" : "relative",
          _v$1 = {
            trackOptions: {
              backgroundColor: theme.background,
              foregroundColor: theme.borderActive
            }
          },
          _v$10 = theme.text,
          _v$11 = theme.text,
          _v$12 = theme.textMuted,
          _v$13 = theme.textMuted,
          _v$14 = theme.textMuted,
          _v$15 = theme.text,
          _v$16 = {
            fg: theme.textMuted
          },
          _v$17 = {
            fg: theme.text
          },
          _v$18 = theme.textMuted,
          _v$19 = {
            fg: theme.success
          },
          _v$20 = {
            fg: theme.text
          };
        _v$9 !== _p$.e && (_p$.e = _$setProp(_el$, "backgroundColor", _v$9, _p$.e));
        _v$0 !== _p$.t && (_p$.t = _$setProp(_el$, "position", _v$0, _p$.t));
        _v$1 !== _p$.a && (_p$.a = _$setProp(_el$2, "verticalScrollbarOptions", _v$1, _p$.a));
        _v$10 !== _p$.o && (_p$.o = _$setProp(_el$5, "fg", _v$10, _p$.o));
        _v$11 !== _p$.i && (_p$.i = _$setProp(_el$9, "fg", _v$11, _p$.i));
        _v$12 !== _p$.n && (_p$.n = _$setProp(_el$10, "fg", _v$12, _p$.n));
        _v$13 !== _p$.s && (_p$.s = _$setProp(_el$12, "fg", _v$13, _p$.s));
        _v$14 !== _p$.h && (_p$.h = _$setProp(_el$14, "fg", _v$14, _p$.h));
        _v$15 !== _p$.r && (_p$.r = _$setProp(_el$30, "fg", _v$15, _p$.r));
        _v$16 !== _p$.d && (_p$.d = _$setProp(_el$67, "style", _v$16, _p$.d));
        _v$17 !== _p$.l && (_p$.l = _$setProp(_el$69, "style", _v$17, _p$.l));
        _v$18 !== _p$.u && (_p$.u = _$setProp(_el$70, "fg", _v$18, _p$.u));
        _v$19 !== _p$.c && (_p$.c = _$setProp(_el$71, "style", _v$19, _p$.c));
        _v$20 !== _p$.w && (_p$.w = _$setProp(_el$76, "style", _v$20, _p$.w));
        return _p$;
      }, {
        e: undefined,
        t: undefined,
        a: undefined,
        o: undefined,
        i: undefined,
        n: undefined,
        s: undefined,
        h: undefined,
        r: undefined,
        d: undefined,
        l: undefined,
        u: undefined,
        c: undefined,
        w: undefined
      });
      return _el$;
    }
  });
}